/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";
import { CosmosComponentContextProps } from "@cosmos/components";
import { PageSearchFragment } from "@cosmos/hygraph-schema";
import { useLocale } from "@epic-mw/i18n";
import dynamic from "next/dynamic";

import { TemplateProviders } from "../templates";

const SearchPage = dynamic(() => import("@cosmos/search").then((m) => m.SearchPage), {
	ssr: false,
});

interface Props {
	pageData: PageSearchFragment;
	componentContext?: CosmosComponentContextProps;
}

export const CosmosPageSearch = ({ pageData, componentContext }: Props): React.JSX.Element => {
	const locale = useLocale();

	return (
		<TemplateProviders componentContext={componentContext}>
			<SearchPage {...pageData} locale={locale}></SearchPage>
		</TemplateProviders>
	);
};
